module.exports = __webpack_public_path__ + "static/media/ram.75050f7e.svg";